function Divider() {
  return <div className="h-[1px] w-full bg-[--gray-200]" />
}

export { Divider }
